<app-back-header-atom
  icon="arrow-left"
  [text]="'payment.title' | translate"
  [textColor]="textColor()"
  [backgroundColor]="backgroundColor()"
  (navigationClick)="back()"
></app-back-header-atom>
